import { render, staticRenderFns } from "./teilnehmer-vorgang-card.vue?vue&type=template&id=b6537dfa&scoped=true"
import script from "./teilnehmer-vorgang-card.vue?vue&type=script&lang=js"
export * from "./teilnehmer-vorgang-card.vue?vue&type=script&lang=js"
import style0 from "./teilnehmer-vorgang-card.vue?vue&type=style&index=0&id=b6537dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6537dfa",
  null
  
)

export default component.exports